import axios from 'axios';
import { BASE_URL } from 'api/index';

export default {
  fetch(teamId) {
    return axios.get(`${BASE_URL}/dispatch/${teamId}/departments`);
  },
};
